/* eslint no-undef: 0 */
import {isServer} from '@adv-mt/mt-utils'

import DealerRepositoriesFactory from '../Repositories/factory.js'
import DealerValueObjectsFactory from '../ValueObjects/factory.js'
import {CheckIsActiveDealerService} from './CheckIsActiveDealerService.js'
import {GetDealerService} from './GetDealerService.js'
import {GetTrackingPhoneDealerService} from './GetTrackingPhoneDealerService.js'

export default class DealerServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {CheckIsActiveDealerService}
   */
  static checkIsActiveDealerService = ({config}) =>
    new CheckIsActiveDealerService({
      repository: DealerRepositoriesFactory.hTTPDealerRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetAdPhoneCallDealerService}
   */
  static getTrackingPhoneDealerService = ({config}) =>
    new GetTrackingPhoneDealerService({
      httpRepository: DealerRepositoriesFactory.hTTPDealerRepository({config}),
      sessionStorageRepository: isServer
        ? DealerRepositoriesFactory.emptyDealerRepository({config})
        : DealerRepositoriesFactory.sessionStorageDealerRepository({config}),
      requestValueObjectFactory: DealerValueObjectsFactory.trackingPhoneRequestParamsDealerValueObject
    })

  static getDealerService = ({config}) =>
    new GetDealerService({
      repository: DealerRepositoriesFactory.hTTPDealerRepository({config})
    })
}
